var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibraryFundraising(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 245,
    viewBox: "0 0 394 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4130_7718)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 393.333,
    height: 245,
    fill: "url(#paint0_radial_4130_7718)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4130_7718)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_4130_7718)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 197,
    cy: 122,
    r: 56,
    fill: "url(#paint1_linear_4130_7718)",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 197,
    cy: 122,
    r: 62,
    stroke: "white",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_4130_7718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215 140H185.4C183.16 140 182.04 140 181.184 139.564C180.431 139.181 179.819 138.569 179.436 137.816C179 136.96 179 135.84 179 133.6V104M187 127V133M196 121V133M205 115V133M214 109V133",
    stroke: "url(#paint2_linear_4130_7718)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 5,
    y: -70,
    width: 329.444,
    height: 383
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_1_4130_7718_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_4130_7718)",
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.112 5.88802C315.236 2.76383 315.248 -2.31701 311.982 -5.29214C288.954 -26.266 260.606 -40.6085 229.958 -46.7047C196.69 -53.322 162.207 -49.9258 130.87 -36.9453C99.5322 -23.9649 72.7476 -1.98331 53.9029 26.2197C35.0583 54.4228 25 87.5805 25 121.5C25 155.42 35.0583 188.577 53.903 216.78C72.7476 244.983 99.5323 266.965 130.87 279.945C162.207 292.926 196.69 296.322 229.958 289.705C260.606 283.608 288.954 269.266 311.982 248.292C315.248 245.317 315.236 240.236 312.112 237.112L266.72 191.72C263.596 188.596 258.551 188.627 255.166 191.465C243.443 201.295 229.401 208.05 214.313 211.052C196.601 214.575 178.243 212.767 161.559 205.856C144.875 198.945 130.615 187.242 120.582 172.227C110.549 157.212 105.194 139.559 105.194 121.5C105.194 103.441 110.549 85.7883 120.582 70.773C130.615 55.7578 144.875 44.0549 161.559 37.1441C178.243 30.2334 196.601 28.4252 214.313 31.9483C229.401 34.9495 243.443 41.7049 255.166 51.5346C258.551 54.3734 263.596 54.4041 266.72 51.2799L312.112 5.88802Z",
    fill: "white",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4130_7718",
    x: 129,
    y: 54,
    width: 136,
    height: 136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0121568 0 0 0 0 0.595686 0 0 0 0 0.333098 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4130_7718"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4130_7718",
    x: 129,
    y: 54,
    width: 136,
    height: 136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00784314 0 0 0 0 0.478431 0 0 0 0 0.282353 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4130_7718"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_4130_7718",
    x: 177,
    y: 102,
    width: 40,
    height: 41.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4130_7718"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_4130_7718",
    x: 5,
    y: -70,
    width: 329.444,
    height: 383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4130_7718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4130_7718",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_4130_7718_clip_path",
    transform: "translate(-5 70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.112 5.88802C315.236 2.76383 315.248 -2.31701 311.982 -5.29214C288.954 -26.266 260.606 -40.6085 229.958 -46.7047C196.69 -53.322 162.207 -49.9258 130.87 -36.9453C99.5322 -23.9649 72.7476 -1.98331 53.9029 26.2197C35.0583 54.4228 25 87.5805 25 121.5C25 155.42 35.0583 188.577 53.903 216.78C72.7476 244.983 99.5323 266.965 130.87 279.945C162.207 292.926 196.69 296.322 229.958 289.705C260.606 283.608 288.954 269.266 311.982 248.292C315.248 245.317 315.236 240.236 312.112 237.112L266.72 191.72C263.596 188.596 258.551 188.627 255.166 191.465C243.443 201.295 229.401 208.05 214.313 211.052C196.601 214.575 178.243 212.767 161.559 205.856C144.875 198.945 130.615 187.242 120.582 172.227C110.549 157.212 105.194 139.559 105.194 121.5C105.194 103.441 110.549 85.7883 120.582 70.773C130.615 55.7578 144.875 44.0549 161.559 37.1441C178.243 30.2334 196.601 28.4252 214.313 31.9483C229.401 34.9495 243.443 41.7049 255.166 51.5346C258.551 54.3734 263.596 54.4041 266.72 51.2799L312.112 5.88802Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4130_7718",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(196.667 122.5) rotate(90) scale(146.5 235.197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECFDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6FEF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4130_7718",
    x1: 197,
    y1: 66,
    x2: 197,
    y2: 178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12B76A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#027A48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4130_7718",
    x1: 178.25,
    y1: 113.75,
    x2: 214.25,
    y2: 150.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12B76A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05603A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4130_7718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393.333,
    height: 245,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryFundraising);
export default __webpack_public_path__ + "static/media/library-fundraising.7e10a981a5724cfcf68daf1292c2a0ad.svg";
export { ForwardRef as ReactComponent };